(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {

// Get the last viewed collection URL from localStorage
    var lastViewedCollection = localStorage.getItem('lastViewedCollection');

// Get button elements
    var button = document.getElementById("back-link");
    var btnPar = document.getElementById("continue-shopping-parent");

// If there's a last viewed collection, display a button/link
    if (lastViewedCollection) {
      btnPar.style.display = "inherit";
      button.setAttribute('href', lastViewedCollection);
    } else {
      btnPar.style.display = "none";
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-page"]) return;
  try {
    

var slider = document.querySelector( '#slider1' );

var stopVideos = function ( element ) {
	var iframes = element.querySelectorAll( 'iframe' );
	let i = 0;
	// stops all videos cause I'm lazy
	while(iframes[i] !== undefined) {
		if ( iframes[i] ) {
			var iframeSrc = iframes[i].src;
			iframes[i].src = iframeSrc;
		}
  		++i;
	}
};

var insertTitles = function () {
	var iframes = document.querySelectorAll( 'iframe' );
	let i = 0;
	while(iframes[i] !== undefined) {
		const wrapper = iframes[i].parentElement.parentElement;
		if (wrapper.nodeName === "P") {
			const vidTitle = document.createElement("h3");
			vidTitle.classList.add("h3");
			vidTitle.classList.add("heading");
			vidTitle.innerText = iframes[i].title;
			wrapper.insertBefore(vidTitle, wrapper.firstChild);
		}
		++i;
	}
}

window.setTimeout(insertTitles, 1500);

var arrows = document.querySelector( '.arrows' )
arrows.onclick = function() { stopVideos(slider); };
var nav = document.querySelector( '.navigation' )
nav.onclick = function() { stopVideos(slider); };


  } catch(e) { console.error(e); }
})();
})();
